import React from 'react'
import styles from '../TrackList/TrackList.module.scss'
import { Empty } from '../../ReleaseInformation.styles'
import Attachment from './Attachment'
import { useTranslation } from 'react-i18next'

export default function AttachmentList({ attachments = [] }) {
  const { t } = useTranslation()

  if (attachments.length === 0)
    return <Empty>{t('release-info.no-attachments-fallback')}</Empty>
  return (
    <div className={styles.list}>
      {attachments.map((attachment, index) => (
        <Attachment key={index} attachment={attachment} />
      ))}
    </div>
  )
}
